var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { getPLCCAccrualData, getPreviousYearData, getFilterData, getCurrentDataIndex, } from '../components/PerksPage/PerkProgress/commons/TrackerUtils';
import { GetAnimationHistoryFromSessionStorage } from '../components/PerksPage/PerkProgress/components/SpendTracker/PerkProgressSpend/PerkProgressSpendHelper';
var PerkProgressContext = React.createContext(null);
var PerkProgressProvider = function (_a) {
    var _b;
    var children = _a.children, perksInfo = _a.perksInfo;
    var _c = React.useState(true), controlToggle = _c[0], setControlToggle = _c[1];
    var isLegacyDesktop = useMediaQuery('(min-width:1200px)');
    var isPlccEnabledPerk = true; // storeUtilities.getFeature('isPlccEnabled');
    var isPlccAcquisitionPerk = true; // storeUtilities.getFeature('isPlccAcquisitionEnabled');
    var pxccCategory = (perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.pxccUserCategory) === 'Enrolled';
    var AcquisitionCategory = (perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.pxccUserCategory) === 'Targeted';
    var plccSwitch = isPlccEnabledPerk && pxccCategory;
    var acquisitionSwitch = isPlccAcquisitionPerk && AcquisitionCategory; // "acquisitioSwitch"
    var _d = React.useState([]), activatedPerks = _d[0], setActivatedPerks = _d[1];
    var initialCurrentDataIndex = ((_b = activatedPerks === null || activatedPerks === void 0 ? void 0 : activatedPerks[0]) === null || _b === void 0 ? void 0 : _b.currentDataIndex) || getCurrentDataIndex(perksInfo);
    var detailsPlcc = getPLCCAccrualData(perksInfo);
    var _e = React.useState(getFilterData(perksInfo)), filterData = _e[0], setFilterData = _e[1];
    var _f = React.useState(getPreviousYearData(perksInfo)), preYearPerk = _f[0], setPreYearPerk = _f[1];
    var _g = React.useState(false), PLCCtoggle = _g[0], setPLCCtoggle = _g[1];
    var _h = React.useState('initial-tier'), slideClass = _h[0], setSlideClass = _h[1];
    var _j = React.useState(initialCurrentDataIndex), currentDataIndex = _j[0], setCurrentDataIndex = _j[1];
    var _k = React.useState(initialCurrentDataIndex), prevDataIndex = _k[0], setPrevDataIndex = _k[1];
    var _l = React.useState(function () {
        return GetAnimationHistoryFromSessionStorage(filterData === null || filterData === void 0 ? void 0 : filterData.length, 'showUnlockAnimation');
    }), showUnlockAnimation = _l[0], setShowUnlockAnimation = _l[1];
    return (React.createElement(PerkProgressContext.Provider, { value: {
            isLegacyDesktop: isLegacyDesktop,
            controlToggle: controlToggle,
            setControlToggle: setControlToggle,
            plccSwitch: plccSwitch,
            acquisitionSwitch: acquisitionSwitch,
            filterData: filterData,
            setFilterData: setFilterData,
            initialCurrentDataIndex: initialCurrentDataIndex,
            currentDataIndex: currentDataIndex,
            setCurrentDataIndex: setCurrentDataIndex,
            preYearPerk: preYearPerk,
            setPreYearPerk: setPreYearPerk,
            detailsPlcc: detailsPlcc,
            PLCCtoggle: PLCCtoggle,
            setPLCCtoggle: setPLCCtoggle,
            slideClass: slideClass,
            setSlideClass: setSlideClass,
            prevDataIndex: prevDataIndex,
            setPrevDataIndex: setPrevDataIndex,
            showUnlockAnimation: showUnlockAnimation,
            setShowUnlockAnimation: setShowUnlockAnimation,
            activatedPerks: activatedPerks,
            setActivatedPerks: function (newerPerk) {
                return setActivatedPerks(function () { return __spreadArray([newerPerk], activatedPerks, true); });
            },
        } }, children));
};
export { PerkProgressProvider, PerkProgressContext };
